<template>
	<div class="t-page_passwordReset">
		<h1>{{ pageText.title }}</h1>
		<form class="t-page_passwordReset__form" :action="action" method="post" @submit.stop.prevent="Submit()">
			<div class="t-input" :class="{_error: password.error}">
				<label>{{ password.label }}</label>
				<input v-model="password.value" :type="password.type" :placeholder="password.placeholder" @focus="Focus('password')">
			</div>
			<div class="t-input" :class="{_error: password_double.error || success === false, _success: success}">
				<label>{{ password_double.label }}</label>
				<input v-model="password_double.value" :type="password_double.type" :placeholder="password_double.placeholder" @focus="Focus('password_double')">
			</div>
			<button class="t-btn" :disabled="!success"><span>{{ pageText.saveBtn }}</span></button>
		</form>
	</div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/courseDetail.json' : 'staticText',
        main: {
            title: "Сброс пароля",
            saveBtn: "Сохранить",
						formNewPasswordTitle: "Введите новый пароль",
            formNewPasswordPlaceholder: "Минимум 6 символов",
            formNewPasswordDoubleTitle: "Ещё раз для проверки",
        }
    };
    import {store} from '../../store'
		import {mapGetters} from 'vuex';
		import {mapActions} from 'vuex';

	export default {
	    computed: {
            ...mapGetters(['mobileState']),
            success(){
                if(this.password.value !== ''){
                    return (this.password.value === this.password_double.value &&
                            this.password.pattern.test(this.password.value) &&
                            this.password_double.pattern.test(this.password_double.value))
                } else{
                    return null
                }
            }
        },
        data(){
            return {
                pageText: {},
                action: '/new-password',
                password: {
                    label: '',
                    type: 'password',
                    value: '',
                    placeholder: '',
                    error: false,
                    pattern: /^[a-zA-Z0-9_]{6,30}$/
                },
                password_double: {
                    label: '',
                    type: 'password',
                    value: '',
                    placeholder: '',
                    error: false,
                    pattern: /^[a-zA-Z0-9_]{6,30}$/
                }
            }
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapActions('msg', ['showMsg']),
            Submit(){
                let fd = new FormData();
                fd.append('new_password', this.password.value);

                this.$http.post(this.action, fd)
                    .then(response => {
                        this.$router.push({ name: 'home'})
                    }, response => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            },
            Focus(key){
                this[key].error = false;
            },
            Load(pageText){
                this.pageText = pageText;
                this.password.label = pageText.formNewPasswordTitle;
                this.password.placeholder = pageText.formNewPasswordPlaceholder;
                this.password_double.label = pageText.formNewPasswordDoubleTitle;
                //   setTimeout(() => {
                //       this.UpdatePreloadState(false);
                //   }, 500)
            }
        },
        beforeRouteLeave (to, from, next) {
            //   this.UpdatePreloadState(true);
            next();
        },
        beforeRouteEnter (to, from, next) {
            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                next(vm => vm.Load(data))
            });
        }
	}
</script>

<style lang="sass">
.t-page_passwordReset
	padding: 24px
	text-align: center
	display: flex
	flex-direction: column
	align-items: center
	h1
		margin: 0 auto 24px
	&__form
		width: 320px
		padding: 24px
		box-shadow: 0 24px 32px rgba(0, 108, 202, 0.1)
		border-radius: 16px
		background: #ffffff
		text-align: left
</style>


// WEBPACK FOOTER //
// src/vue_pages/Profile/PasswordReset.vue